<template>
    <div id="planing_satker_bidang">

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Unit Kerja</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data Satker" data-toggle="modal" data-target="#m_tambah_satker"><i class="material-icons">add</i></button>
                                <!-- <button @click="getDataUrusan()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button> -->
                            </span>
                            <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info kepala_table_f tabel_center">
                            <th style="width: 5%">No.</th>
                            <th style="width: 30%">Unit Kerja</th>
                            <th style="width: 20%">Instansi</th>
                            <th style="width: 25%">Alamat</th>
                            <th style="width: 10%">Unit Induk</th>
                            <th style="width: 10%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{data.unit_kerja}}</td>
                                <td>{{data.nama_instansi}}</td>
                                <td>{{data.alamat}}</td>
                                <td class="text-center">
                                    <div v-if="data.unit_induk">
                                        YA
                                    </div>
                                    <div v-if="!data.unit_induk">
                                        TIDAK
                                    </div>
                                </td>
                                <td class="text-center" >
                                
                                    <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Ubah Satker" data-toggle="modal" data-target="#m_edit_satker">
                                        <i class="material-icons" >create</i>
                                    </button>
                                        &nbsp;
                                    <button @click="removeSatker(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Satker" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_satker" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH SATUAN KERJA</h4>
                                </div>
                               
                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Instansi</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <autocomplete
                                                        :url="URL+ 'api/v1/simpeg_instansi/autocomplete'"
                                                        :customHeaders="{authorization: 'kikensbatara '+token }"
                                                        anchor="instansi"
                                                        :initValue="''"
                                                        :placeholder="instansi_full"
                                                        :classes="{ input: 'form-control'}"
                                                        label="writer"
                                                        :onShouldRenderChild="renderChild"
                                                        :on-select="getAuto">
                                                    </autocomplete>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Unit Kerja</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.unit_kerja" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Kode</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.kode" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Unit Kerja Induk</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control" v-model="satker.unit_induk">
                                                        <option value="1">YA</option>
                                                        <option value="0">TIDAK</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Alamat</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.alamat" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  

                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="addSatker()" class="btn btn-info waves-effect">TAMBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_satker" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                
                                    <h4 class="modal-title" id="largeModalLabel">EDIT UNIT KERJA</h4>
                                </div>
                               
                                <div class="modal-body">

                                    <div class="row clearfix" v-if="cek_edit">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Instansi</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <autocomplete
                                                        :url="URL+ 'api/v1/simpeg_instansi/autocomplete'"
                                                        :customHeaders="{authorization: 'kikensbatara '+token }"
                                                        anchor="instansi"
                                                        :initValue="satker.instansi_full"
                                                        :placeholder="satker.instansi_full"
                                                        :classes="{ input: 'form-control'}"
                                                        label="writer"
                                                        :onShouldRenderChild="renderChild"
                                                        :on-select="getAuto">
                                                    </autocomplete>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Unit Kerja</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.unit_kerja" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Kode</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.kode" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Unit Kerja Induk</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control" v-model="satker.unit_induk">
                                                        <option value="1">YA</option>
                                                        <option value="0">TIDAK</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">Alamat Satker</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="satker.alamat" :required="true" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  

                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="updateSatker()" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" @click="emptyData()"  class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT SATKER xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>


    const URL_SERVER = URL_APP;
    const ADD_URL = URL_APP+'api/v1/simpeg_unit_kerja/';

    import Autocomplete from 'vue2-autocomplete-js'

    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {

                satker : {
                    id : '',
                    instansi : '',
                    instansi_full : '',
                    unit_kerja : '',
                    kode : '',
                    alamat : '',
                    unit_induk : 0,
                },

                instansi : '',
                instansi_full : '',


                list_data : [],
                list_urusan : [],
                list_bidang_urusan : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER,
                cek_edit : false,
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                  console.log(res_data);
                })
            },
            selectData : function(data){
                console.log(data);
                this.satker = {
                    id : data.id,
                    instansi : data.instansi,
                    instansi_full : data.nama_instansi,
                    unit_kerja : data.unit_kerja,
                    kode : data.kode,
                    alamat : data.alamat,
                    unit_induk : data.unit_induk,
                }
                this.cek_edit = true;
            },
            emptyData : function(){
                this.cek_edit = false;
            },

            addSatker : function(){
                fetch(ADD_URL+"addSatker", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify(this.satker)
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

            removeSatker : function(id){
                fetch(ADD_URL+"removeSatker", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify({
                        id : id
                    })
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

            updateSatker : function(){
                fetch(ADD_URL+"updateSatker", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                    },
                    body : JSON.stringify(this.satker)
                }).then(()=>{
                    this.alertku("success", "Sukses Menghapus Data!");
                    this.getData();
                });
            },

        //TAMBAHAN



       
        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.instansi}</b></span>
                <span style='font-size:80%'>${data.alamat}</span>
                `
            },
            getAuto : function(obj){
                this.satker.instansi = obj.id
                this.satker.instansi_full = obj.instansi

                console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.id_renstra != '') {
                    this.check_data_add = true;
                }
            } 
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
